var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaylists = function SvgPlaylists(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.555 7.16815L12.752 9.30015C12.889 9.39147 13.0013 9.5162 13.0789 9.66133C13.1566 9.80647 13.1972 9.96854 13.1972 10.1332C13.1972 10.2978 13.1566 10.4598 13.0789 10.605C13.0013 10.7501 12.889 10.8738 12.752 10.9652L9.555 13.0972C9.4044 13.1976 9.22935 13.2553 9.04852 13.2641C8.86769 13.2729 8.68787 13.2324 8.52824 13.147C8.36861 13.0616 8.23516 12.9345 8.14213 12.7792C8.0491 12.6238 7.99998 12.4462 8 12.2652V8.00215C7.99961 7.82094 8.04847 7.64303 8.14136 7.48743C8.23424 7.33183 8.36766 7.2044 8.52735 7.11875C8.68705 7.0331 8.86701 6.99245 9.04802 7.00115C9.22902 7.00986 9.40426 7.06758 9.555 7.16815Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3149 13.4442C18.7672 12.3522 19 11.1819 19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.3869 1 10 1C7.61305 1 5.32387 1.94821 3.63604 3.63604C1.94821 5.32387 1 7.61305 1 10C1 11.1819 1.23279 12.3522 1.68508 13.4442C2.13738 14.5361 2.80031 15.5282 3.63604 16.364C4.47177 17.1997 5.46392 17.8626 6.55585 18.3149C7.64778 18.7672 8.8181 19 10 19C11.1819 19 12.3522 18.7672 13.4442 18.3149C14.5361 17.8626 15.5282 17.1997 16.364 16.364C17.1997 15.5282 17.8626 14.5361 18.3149 13.4442Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPlaylists;